import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, Fragment as _Fragment, renderList as _renderList, resolveDynamicComponent as _resolveDynamicComponent, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01abf1fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-card_tooltip-content" }
const _hoisted_2 = { class: "task-card_tooltip-content" }
const _hoisted_3 = ["textContent"]
const _hoisted_4 = ["textContent"]
const _hoisted_5 = ["textContent"]
const _hoisted_6 = { class: "task-card__menu-item" }
const _hoisted_7 = { class: "task-card__menu-item" }
const _hoisted_8 = { class: "task-card__menu-item" }
const _hoisted_9 = { class: "task-card__menu-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "task-card__negative" }, "Удалить тикет", -1))

import { computed, CSSProperties, inject, PropType, ref, useSlots } from 'vue';
import {
  TirPmIconView,
  TirPmContextMenu,
  TirPmContextMenuMouseButtonEnum,
  TirPmContextMenuButton,
  TirPmPopover,
  PopoverColorEnum,
  PopoverPositionEnum,
  TirPmNotificationEventBus,
  TirPmNotificationModel,
  TirPmNotificationGroup,
  TirPmTooltipElement,
} from 'tir-components';
import { ListBulletIcon, Bars3BottomLeftIcon } from 'tir-style-system/icons/solid';
import { RouterLink, useRouter } from 'vue-router';
import { RemoveTaskModal } from '@/components';
import NamespaceIconView from '@/pages/project-namespaces-page/components/namespace-card/namespace-icon-view.vue';
import { TaskModel } from '@/components/tasks-kanban/models';
import { ListItemModel } from '@/components/tir-pm-list/models';
import { TaskViewElementEnum } from '@/components/tasks-kanban/enums';
import { TaskColumnModel } from '../../models';
import {
  TaskCardDifficulty,
  TaskCardEstimateTime,
  TaskCardPriority,
  TaskCardStatus,
  TaskCardWorkTime,
} from '@/components/tir-pm-list/components/task-card/components';
import {
  ArrowsPointingOutIcon,
  CurtainIcon,
  MapIcon,
  ShareIcon,
  TrashIcon,
} from 'tir-style-system/icons/outline';
import { copyToClipboard } from '@/components/task-forms/utils';
import { CurrentUser, UserRoleEnum } from 'tir-pm-user-core';

/**Слоты */

export default /*#__PURE__*/_defineComponent({
  __name: 'task-card',
  props: {
  /**Данные задачи */
  task: { type: Object as PropType<TaskModel>, required: true },
  /**Колонки */
  columns: { type: Array as PropType<TaskColumnModel[]>, default: () => [] },
  /**Страница Все задачи текущего юзера */
  checkAllTasks: { type: Boolean as PropType<boolean>, default: false },
  /**Настройки отображения */
  viewSettings: {
    type: Array as PropType<Array<TaskViewElementEnum>>,
    default: () => [
      TaskViewElementEnum.Namespace,
      TaskViewElementEnum.Queue,
      TaskViewElementEnum.Number,
      TaskViewElementEnum.Name,
      TaskViewElementEnum.Status,
      TaskViewElementEnum.Difficulty,
      TaskViewElementEnum.Priority,
      TaskViewElementEnum.EstimateTime,
      TaskViewElementEnum.WorkTime,
    ],
  },
  /**Ширина карточки */
  width: { type: String, default: '100%' },
  /**Дизейбл */
  isDisabled: {
    type: Boolean,
    default: false,
  },
  /**Заливка */
  isFill: {
    type: Boolean,
    default: false,
  },
  /**Слот слева всегда видим */
  slotLeftVisible: {
    type: Boolean,
    default: false,
  },
},
  emits: ["openTaskDrawer", "removeTask"],
  setup(__props, { emit }) {

const props = __props;

const slots = useSlots();
/**Роутер */
const router = useRouter();

// #region defineProps
/**Параметры */

// #endregion defineProps

// #region defineEmits

// #endregion defineEmits

// #region Переменные
const parameterTypes = [
  TaskViewElementEnum.Difficulty,
  TaskViewElementEnum.Priority,
  TaskViewElementEnum.Status,
  TaskViewElementEnum.EstimateTime,
  TaskViewElementEnum.WorkTime,
];

/**Является ли юзер админом */
const isProjectAdmin = !!props.task.Project?.Admins?.some((a) => a.Id == CurrentUser.Id);
/**Является ли юзер овнером */
const isOwner = CurrentUser.Roles.includes(UserRoleEnum.Owner);
// #endregion Переменные

// #region refs
/**Ссылка на компонент контекстного меню */
const $contextMenu = ref<InstanceType<typeof TirPmContextMenu>>();
/**Окно удаления задачи */
const $removeTaskModal = ref<InstanceType<typeof RemoveTaskModal>>();
// #endregion refs

// #region computed
/**Активен левый слот */
const haveLeftSlot = computed(() => slots.left?.());
/**Минимальная ширина */
const minWidth = computed(() => {
  if (props.columns.some((column) => !column.MinWidth)) return 'auto';

  const columnsCalcStr = props.columns.map((column) => column.MinWidth).join(' + ');

  return `calc(${columnsCalcStr} + ${0.75 * (props.columns.length - 1)}rem + 1.25rem)`;
});
/**Стили карточки */
const style = computed<CSSProperties>(() => ({ width: props.width, minWidth: minWidth.value }));

const parameterColumns = computed(() => {
  const filtredColumns = props.columns.filter(
    (column) => parameterTypes.includes(column.Type) && props.viewSettings.includes(column.Type),
  );
  return filtredColumns.map((column) => {
    return new ListItemModel({
      Type: column.Type,
      Width: column.Width,
      MinWidth: column.MinWidth,
    });
  });
});

const elementsStyles = computed<
  Record<'Project' | 'Namespace' | 'Queue' | 'Id' | 'Name', CSSProperties>
>(() => {
  const projectColumn = getColumnByViewElement(TaskViewElementEnum.Project);
  const namespaceColumn = getColumnByViewElement(TaskViewElementEnum.Namespace);
  const queueColumn = getColumnByViewElement(TaskViewElementEnum.Queue);
  const idColumn = getColumnByViewElement(TaskViewElementEnum.Number);
  const nameColumn = getColumnByViewElement(TaskViewElementEnum.Name);

  return {
    Project: {
      width: projectColumn?.Width ?? '1.5rem',
      minWidth: projectColumn?.MinWidth,
    },
    Namespace: {
      width: namespaceColumn?.Width ?? '1.5rem',
      minWidth: namespaceColumn?.MinWidth,
    },
    Queue: {
      width: queueColumn?.Width ?? '13rem',
      minWidth: queueColumn?.MinWidth,
    },
    Id: {
      width: idColumn?.Width ?? '5rem',
      minWidth: idColumn?.MinWidth,
    },
    Name: {
      width: nameColumn?.Width ?? '65.8125rem',
      minWidth: nameColumn?.MinWidth,
    },
  };
});
// #endregion computed

// #region Функции
const getColumnByViewElement = (viewElement: TaskViewElementEnum) => {
  return props.columns.find((column) => column.Type === viewElement);
};

/**Получение компонента для параметра задачи */
const getTaskParameterComponent = (type: TaskViewElementEnum) => {
  switch (type) {
    case TaskViewElementEnum.Difficulty:
      return TaskCardDifficulty;
    case TaskViewElementEnum.Priority:
      return TaskCardPriority;
    case TaskViewElementEnum.Status:
      return TaskCardStatus;
    case TaskViewElementEnum.EstimateTime:
      return TaskCardEstimateTime;
    case TaskViewElementEnum.WorkTime:
      return TaskCardWorkTime;
  }
};
/**Открыть карту проекта */
const openSchema = computed(() => {
  return router.resolve({
    name: 'project-map',
    params: {
      taskId: props.task.Id,
      projectId: props.task.ProjectId,
    },
  });
});

/**Добавить оповещение */
const addNotification = (message: string, isError: boolean = false, life?: number) => {
  TirPmNotificationEventBus.emit(
    'add',
    new TirPmNotificationModel({
      title: message,
      type: isError ? 'error' : 'success',
      group: 'employee-task-card',
      life: life ?? 2000,
      closable: true,
    }),
  );
};

/**Скопировать название и ссылку */
const copyNameAndLinkTask = async () => {
  const routeParams = router.currentRoute.value.params;
  const projectId = routeParams.projectId;

  if (!projectId || !props.task.Queues[0].Id) return;

  const route = router.resolve({
    name: 'task-detail',
    params: {
      projectId: projectId,
      queueId: props.task.Queues[0].Id,
      taskId: props.task.Id,
      namespaceId: props.task.NamespaceInfo[0].Id,
    },
  });

  if (!route?.href) return;

  const origin =
    window.location.hostname === 'localhost' ? 'https://beta.hub-pm.com' : window.location.origin;

  const link = origin + route.href;
  const textContent = `${props.task.Id} ${props.task.Name}`;

  if (await copyToClipboard(`[${textContent}](${link})`)) {
    $contextMenu.value.close();
    addNotification('Название и ссылка тикета скопирована');
    console.log(7);
  }
};

/**Открыть окно удаления задачи */
const openRemoveModal = (id: number, name: string) => {
  $removeTaskModal.value?.open(id, name);
};
/**Удаление задачи из списка */
const onSuccessRemove = (taskId: number) => {
  emit('removeTask', taskId);
};

/**Открыть детальную страницу */
const goToDetail = computed(() => {
  return router.resolve({
    name: 'task-detail',
    params: {
      projectId: props.task.ProjectId,
      queueId: props.task.Queues[0].Id,
      taskId: props.task.Id,
      namespaceId: props.task.NamespaceInfo[0].Id,
    },
  });
});

/**Открыть задачу в шторке */
const openInDrawer = () => {
  if (!props.task.ProjectId) return;

  $contextMenu.value?.close();

  emit('openTaskDrawer', props.task.Id);
};
// #endregion Функции

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TirPmContextMenu), {
    ref_key: "$contextMenu",
    ref: $contextMenu,
    "min-width": "20rem",
    maxHeight: "max-content",
    "trigger-buttons": [_unref(TirPmContextMenuMouseButtonEnum).Right]
  }, {
    content: _withCtx(() => [
      _createVNode(_unref(TirPmContextMenuButton), { onClick: openInDrawer }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(CurtainIcon), { class: "task-card__menu-icon" }),
            _createTextVNode(" Открыть в шторке ")
          ])
        ]),
        _: 1
      }),
      _createVNode(_unref(RouterLink), {
        to: goToDetail.value,
        target: "_blank"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TirPmContextMenuButton), null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_unref(ArrowsPointingOutIcon), { class: "task-card__menu-icon" }),
                _createTextVNode(" Открыть в новой вкладке ")
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["to"]),
      (__props.task?.ProjectId)
        ? (_openBlock(), _createBlock(_unref(RouterLink), {
            key: 0,
            to: openSchema.value
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(TirPmContextMenuButton), null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_unref(MapIcon), { class: "task-card__menu-icon" }),
                    _createTextVNode(" Посмотреть карту проекта ")
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true),
      _createVNode(_unref(TirPmContextMenuButton), {
        onClick: copyNameAndLinkTask,
        class: "task-card__menu-item"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ShareIcon), { class: "task-card__menu-icon" }),
          _createTextVNode(" Скопировать название и ссылку ")
        ]),
        _: 1
      }),
      (isProjectAdmin || _unref(isOwner))
        ? (_openBlock(), _createBlock(_unref(TirPmContextMenuButton), {
            key: 1,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (openRemoveModal(__props.task.Id, __props.task.Name)))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_unref(TrashIcon), { class: "task-card__menu-icon task-card__negative" }),
                _hoisted_10
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(TirPmNotificationGroup), {
        group: "employee-task-card",
        position: "top-right",
        zIndex: 20000
      }),
      _createVNode(_unref(RouterLink), {
        to: goToDetail.value,
        class: _normalizeClass(['task-card', { 'is-disabled': __props.isDisabled, 'is-fill': __props.isFill }]),
        style: _normalizeStyle(style.value),
        onMousedown: [
          _withModifiers(openInDrawer, ["left","prevent"]),
          _cache[1] || (_cache[1] = _withModifiers(() => {}, ["middle","prevent"]))
        ]
      }, {
        default: _withCtx(() => [
          (__props.viewSettings?.includes(_unref(TaskViewElementEnum).Project))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "task-card_project",
                style: _normalizeStyle(elementsStyles.value.Project)
              }, [
                (__props.task?.Project)
                  ? (_openBlock(), _createBlock(_unref(TirPmTooltipElement), { key: 0 }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, _toDisplayString(__props.task.Project.Name), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_unref(TirPmIconView), {
                          size: 24,
                          "is-rounded": "",
                          "color-code": __props.task.Project.PreviewColor,
                          "image-load-url": __props.task.Project.ImageUrl,
                          "is-bordered": false
                        }, {
                          mainSlot: _withCtx(() => [
                            _createTextVNode(_toDisplayString(__props.task.Project.Name?.[0]), 1)
                          ]),
                          _: 1
                        }, 8, ["color-code", "image-load-url"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], 4))
            : _createCommentVNode("", true),
          (__props.viewSettings?.includes(_unref(TaskViewElementEnum).Namespace))
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "task-card_namespace",
                style: _normalizeStyle(elementsStyles.value.Namespace)
              }, [
                (__props.task?.NamespaceInfo?.length)
                  ? (_openBlock(), _createBlock(_unref(TirPmTooltipElement), { key: 0 }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, _toDisplayString(__props.task.NamespaceInfo[0].Name), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(NamespaceIconView, {
                          icon: __props.task.NamespaceInfo[0].IconUrl,
                          color: __props.task.NamespaceInfo[0].Color
                        }, null, 8, ["icon", "color"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], 4))
            : _createCommentVNode("", true),
          (__props.viewSettings?.includes(_unref(TaskViewElementEnum).Queue))
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "task-card_queue",
                style: _normalizeStyle(elementsStyles.value.Queue)
              }, [
                (__props.task?.Queues?.length)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_unref(ListBulletIcon), { class: "task-card_icon" }),
                      _createElementVNode("div", {
                        textContent: _toDisplayString(__props.task.Queues[0].Name),
                        class: "task-card_queue_text"
                      }, null, 8, _hoisted_3)
                    ], 64))
                  : _createCommentVNode("", true)
              ], 4))
            : _createCommentVNode("", true),
          (__props.viewSettings?.includes(_unref(TaskViewElementEnum).Number))
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                textContent: _toDisplayString(__props.task.Id),
                class: "task-card_id",
                style: _normalizeStyle(elementsStyles.value.Id)
              }, null, 12, _hoisted_4))
            : _createCommentVNode("", true),
          (__props.viewSettings?.includes(_unref(TaskViewElementEnum).Name))
            ? (_openBlock(), _createElementBlock("div", {
                key: 4,
                class: "task-card_name",
                style: _normalizeStyle(elementsStyles.value.Name)
              }, [
                _createVNode(_unref(Bars3BottomLeftIcon), { class: "task-card_icon" }),
                _createElementVNode("div", {
                  textContent: _toDisplayString(__props.task.Name),
                  class: "task-card_name_text"
                }, null, 8, _hoisted_5)
              ], 4))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parameterColumns.value, (element, index) => {
            return (_openBlock(), _createBlock(_resolveDynamicComponent(getTaskParameterComponent(element.Type)), {
              key: index,
              element: element,
              task: __props.task
            }, null, 8, ["element", "task"]))
          }), 128)),
          (haveLeftSlot.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 5,
                class: _normalizeClass(['task-card_left', { 'slot-left-visible': __props.slotLeftVisible }]),
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
              }, [
                _renderSlot(_ctx.$slots, "left")
              ], 2))
            : _createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["to", "class", "style", "onMousedown"]),
      _createVNode(_unref(RemoveTaskModal), {
        ref_key: "$removeTaskModal",
        ref: $removeTaskModal,
        onSuccessRemove: onSuccessRemove
      }, null, 512)
    ]),
    _: 3
  }, 8, ["trigger-buttons"]))
}
}

})